import React from 'react';
import * as styles from './index.module.scss';

export default ({ children }) => <span className={styles.HeaderRightSide}>{children}</span>;
